import {
  TableFooter,
  TableRow,
  TableCell,
  Typography,
  Select,
  Pagination,
} from '@astro-ui/components'
import styled from 'styled-components'

const defaultPageLimitOptions = [{ value: 10 }, { value: 20 }, { value: 30 }]

export type TableFooterPaginationCursorPageSizeOptionsType = {
  value: number
}

export type TableFooterPaginationCursorPropsType = {
  pageIndex: number
  pageSize: number
  numberOfElements: number
  prevCursor: string
  nextCursor: string
  customPageLimitOptions?: TableFooterPaginationCursorPageSizeOptionsType[]
  customColSpan?: number
  firstPage?: number
  onChangePageSize: (selected: { value: number }) => void
  onClickBtnPage: (page: number, selectedCursor: string) => void
  sticky?: boolean
}

const TableFooterPaginationCursor = ({
  pageIndex,
  pageSize,
  numberOfElements,
  prevCursor,
  nextCursor,
  customPageLimitOptions = defaultPageLimitOptions,
  customColSpan = 11,
  firstPage = 1,
  onChangePageSize,
  onClickBtnPage,
  sticky = true,
}: TableFooterPaginationCursorPropsType) => (
  <S.TableFooterSticky sticky={sticky}>
    <TableRow>
      <TableCell colSpan={customColSpan}>
        <S.WrapperTablePagination>
          <S.WrapperLimitCombobox>
            <Select
              required
              displayKey="value"
              value={pageSize.toString()}
              options={customPageLimitOptions}
              onChange={onChangePageSize}
            />
            <Typography variant="body2" marginLeft="10px" fontWeight="bold">
              Tiap halaman
            </Typography>
          </S.WrapperLimitCombobox>
          <Pagination
            pageIndex={pageIndex}
            pageSize={pageSize}
            numberOfElements={numberOfElements}
            onClick={onClickBtnPage}
            firstPage={firstPage}
            cursor={{ next_cursor: nextCursor, prev_cursor: prevCursor }}
            enableCustomDisabledNextPage
            isNextPageDisabled={!nextCursor}
          />
        </S.WrapperTablePagination>
      </TableCell>
    </TableRow>
  </S.TableFooterSticky>
)

const S = {
  TableFooterSticky: styled(TableFooter)<{ sticky?: boolean }>`
    width: 100%;
    position: ${({ sticky }) => (sticky ? 'sticky' : 'static')};
    bottom: 0;
    z-index: 1;
    background-color: white;
  `,
  WrapperTablePagination: styled.div`
    display: flex;
    justify-content: space-between;
    align-items: center;
    padding: 10px 20px;
  `,
  WrapperLimitCombobox: styled.div`
    display: flex;
    align-items: center;
  `,
}

export default TableFooterPaginationCursor
